function sameCoordinate(left, right) {
  return left[0] === right[0] && left[1] === right[1];
}

// Google Maps paths are open, while GeoJSON rings are closed. Normalize either
// representation to one open ring before displaying, editing, or re-closing it.
export function normalizeOpenPolygonRing(coordinates) {
  const normalized = [];

  for (const coordinate of (coordinates || [])) {
    if (!Array.isArray(coordinate) || coordinate.length < 2) continue;

    const point = [Number(coordinate[0]), Number(coordinate[1])];
    if (!Number.isFinite(point[0]) || !Number.isFinite(point[1])) continue;
    if (normalized.length && sameCoordinate(point, normalized[normalized.length - 1])) continue;

    // The first return to the starting point closes the exterior ring. Ignore
    // stale vertices after it; old saved fields can contain many such points.
    if (normalized.length >= 3 && sameCoordinate(point, normalized[0])) break;

    normalized.push(point);
  }

  return normalized;
}

export function closePolygonRing(coordinates) {
  const normalized = normalizeOpenPolygonRing(coordinates);
  if (normalized.length < 3) return normalized;
  return normalized.concat([[normalized[0][0], normalized[0][1]]]);
}
